module.exports = __webpack_public_path__ + "img/skype_contact.0ef0faab.png";